import { render, staticRenderFns } from "./Tier2Nav.vue?vue&type=template&id=675dadba&"
import script from "./Tier2Nav.vue?vue&type=script&lang=js&"
export * from "./Tier2Nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports